module.exports = __webpack_public_path__ + "static/img/sj1.af1761f7.png";